<ng-container *ngIf="ventilationAutomatedModeLevel$ | async | ready as feature">
  <div class="ventilation-settings-tile gap-[24px]">
    <div class="justify-between items-center">
      <h3>
        {{
          '+INSTALLATIONS.INSTALLATION.VENTILATION.AUTOMATED_MODE_LEVEL_SETTINGS.TITLE' | translate
        }}
      </h3>
    </div>
    <div class="settings-wrapper">
      <div class="flex flex-col">
        <h4>
          {{
            '+INSTALLATIONS.INSTALLATION.VENTILATION.AUTOMATED_MODE_LEVEL_SETTINGS.MINIMUM_LEVEL'
              | translate
          }}
        </h4>
        <mat-radio-group
          class="flex flex-col gap-[8px]"
          fxLayout="column"
          [ngModel]="minimumCheckedLevel"
          (ngModelChange)="onVentilationMinimumCheckedLevelChange($event)"
        >
          <vi-radio-button
            *ngFor="let level of feature.commands.setLevels?.params?.minimumLevel.constraints.enum"
            [attr.data-at-bypass-mode]="level"
            [value]="level"
            [label]="level | translateVentilationProgram"
            [checked]="level === minimumCheckedLevel"
            [attr.data-at-checked]="level === minimumCheckedLevel"
          >
          </vi-radio-button>
        </mat-radio-group>
      </div>
      <div class="flex flex-col">
        <h4 class="maximum-level-label">
          {{
            '+INSTALLATIONS.INSTALLATION.VENTILATION.AUTOMATED_MODE_LEVEL_SETTINGS.MAXIMUM_LEVEL'
              | translate
          }}
        </h4>
        <div
          *ngFor="let level of feature.commands.setLevels?.params?.maximumLevel.constraints.enum"
        ></div>
        <mat-radio-group
          class="flex flex-col gap-[8px]"
          fxLayout="column"
          [ngModel]="maximumCheckedLevel"
          (ngModelChange)="onVentilationMaximumCheckedLevelChange($event)"
        >
          <vi-radio-button
            *ngFor="let level of feature.commands.setLevels?.params?.maximumLevel.constraints.enum"
            [attr.data-at-bypass-mode]="level"
            [value]="level"
            [label]="level | translateVentilationProgram"
            [checked]="level === maximumCheckedLevel"
            [attr.data-at-checked]="level === maximumCheckedLevel"
          >
          </vi-radio-button>
        </mat-radio-group>
      </div>
      <div class="flex flex-col w-fit justify-end items-end mt-[24px]">
        <button
          mat-button
          mat-stroked-button
          class="ventilation-automated-mode-level-btn w-full"
          (click)="resetToDefault()"
        >
          {{
            '+INSTALLATIONS.INSTALLATION.VENTILATION.AUTOMATED_MODE_LEVEL_SETTINGS.RESET_TO_DEFAULT'
              | translate
          }}
        </button>
        <button
          mat-button
          mat-stroked-button
          class="ventilation-automated-mode-level-btn w-full"
          [disabled]="isInvalidLevelSelection"
          (click)="save()"
        >
          {{
            '+INSTALLATIONS.INSTALLATION.VENTILATION.AUTOMATED_MODE_LEVEL_SETTINGS.SAVE' | translate
          }}
        </button>
      </div>
    </div>
    <div *ngIf="isInvalidLevelSelection">
      <mat-error class="mt-[10px]">{{
        '+INSTALLATIONS.INSTALLATION.VENTILATION.AUTOMATED_MODE_LEVEL_SETTINGS.RANGE_CONFLICT_ERROR'
          | translate
      }}</mat-error>
    </div>
  </div>
</ng-container>
